!(function (e) {
  var t = (function (u, D, f) {
    'use strict';
    var k, H;
    if (
      ((function () {
        var e;
        var t = {
          lazyClass: 'lazyload',
          loadedClass: 'lazyloaded',
          loadingClass: 'lazyloading',
          preloadClass: 'lazypreload',
          errorClass: 'lazyerror',
          autosizesClass: 'lazyautosizes',
          fastLoadedClass: 'ls-is-cached',
          iframeLoadMode: 0,
          srcAttr: 'data-src',
          srcsetAttr: 'data-srcset',
          sizesAttr: 'data-sizes',
          minSize: 40,
          customMedia: {},
          init: true,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: true,
          ricTimeout: 0,
          throttleDelay: 125,
        };
        H = u.lazySizesConfig || u.lazysizesConfig || {};
        for (e in t) {
          if (!(e in H)) {
            H[e] = t[e];
          }
        }
      })(),
      !D || !D.getElementsByClassName)
    ) {
      return { init: function () {}, cfg: H, noSupport: true };
    }
    var O = D.documentElement,
      i = u.HTMLPictureElement,
      P = 'addEventListener',
      $ = 'getAttribute',
      q = u[P].bind(u),
      I = u.setTimeout,
      U = u.requestAnimationFrame || I,
      o = u.requestIdleCallback,
      j = /^picture$/i,
      r = ['load', 'error', 'lazyincluded', '_lazyloaded'],
      a = {},
      G = Array.prototype.forEach,
      J = function (e, t) {
        if (!a[t]) {
          a[t] = new RegExp('(\\s|^)' + t + '(\\s|$)');
        }
        return a[t].test(e[$]('class') || '') && a[t];
      },
      K = function (e, t) {
        if (!J(e, t)) {
          e.setAttribute('class', (e[$]('class') || '').trim() + ' ' + t);
        }
      },
      Q = function (e, t) {
        var a;
        if ((a = J(e, t))) {
          e.setAttribute('class', (e[$]('class') || '').replace(a, ' '));
        }
      },
      V = function (t, a, e) {
        var i = e ? P : 'removeEventListener';
        if (e) {
          V(t, a);
        }
        r.forEach(function (e) {
          t[i](e, a);
        });
      },
      X = function (e, t, a, i, r) {
        var n = D.createEvent('Event');
        if (!a) {
          a = {};
        }
        a.instance = k;
        n.initEvent(t, !i, !r);
        n.detail = a;
        e.dispatchEvent(n);
        return n;
      },
      Y = function (e, t) {
        var a;
        if (!i && (a = u.picturefill || H.pf)) {
          if (t && t.src && !e[$]('srcset')) {
            e.setAttribute('srcset', t.src);
          }
          a({ reevaluate: true, elements: [e] });
        } else if (t && t.src) {
          e.src = t.src;
        }
      },
      Z = function (e, t) {
        return (getComputedStyle(e, null) || {})[t];
      },
      s = function (e, t, a) {
        a = a || e.offsetWidth;
        while (a < H.minSize && t && !e._lazysizesWidth) {
          a = t.offsetWidth;
          t = t.parentNode;
        }
        return a;
      },
      ee = (function () {
        var a, i;
        var t = [];
        var r = [];
        var n = t;
        var s = function () {
          var e = n;
          n = t.length ? r : t;
          a = true;
          i = false;
          while (e.length) {
            e.shift()();
          }
          a = false;
        };
        var e = function (e, t) {
          if (a && !t) {
            e.apply(this, arguments);
          } else {
            n.push(e);
            if (!i) {
              i = true;
              (D.hidden ? I : U)(s);
            }
          }
        };
        e._lsFlush = s;
        return e;
      })(),
      te = function (a, e) {
        return e
          ? function () {
              ee(a);
            }
          : function () {
              var e = this;
              var t = arguments;
              ee(function () {
                a.apply(e, t);
              });
            };
      },
      ae = function (e) {
        var a;
        var i = 0;
        var r = H.throttleDelay;
        var n = H.ricTimeout;
        var t = function () {
          a = false;
          i = f.now();
          e();
        };
        var s =
          o && n > 49
            ? function () {
                o(t, { timeout: n });
                if (n !== H.ricTimeout) {
                  n = H.ricTimeout;
                }
              }
            : te(function () {
                I(t);
              }, true);
        return function (e) {
          var t;
          if ((e = e === true)) {
            n = 33;
          }
          if (a) {
            return;
          }
          a = true;
          t = r - (f.now() - i);
          if (t < 0) {
            t = 0;
          }
          if (e || t < 9) {
            s();
          } else {
            I(s, t);
          }
        };
      },
      ie = function (e) {
        var t, a;
        var i = 99;
        var r = function () {
          t = null;
          e();
        };
        var n = function () {
          var e = f.now() - a;
          if (e < i) {
            I(n, i - e);
          } else {
            (o || r)(r);
          }
        };
        return function () {
          a = f.now();
          if (!t) {
            t = I(n, i);
          }
        };
      },
      e = (function () {
        var v, m, c, h, e;
        var y, z, g, p, C, b, A;
        var n = /^img$/i;
        var d = /^iframe$/i;
        var E = 'onscroll' in u && !/(gle|ing)bot/.test(navigator.userAgent);
        var _ = 0;
        var w = 0;
        var M = 0;
        var N = -1;
        var L = function (e) {
          M--;
          if (!e || M < 0 || !e.target) {
            M = 0;
          }
        };
        var x = function (e) {
          if (A == null) {
            A = Z(D.body, 'visibility') == 'hidden';
          }
          return A || !(Z(e.parentNode, 'visibility') == 'hidden' && Z(e, 'visibility') == 'hidden');
        };
        var W = function (e, t) {
          var a;
          var i = e;
          var r = x(e);
          g -= t;
          b += t;
          p -= t;
          C += t;
          while (r && (i = i.offsetParent) && i != D.body && i != O) {
            r = (Z(i, 'opacity') || 1) > 0;
            if (r && Z(i, 'overflow') != 'visible') {
              a = i.getBoundingClientRect();
              r = C > a.left && p < a.right && b > a.top - 1 && g < a.bottom + 1;
            }
          }
          return r;
        };
        var t = function () {
          var e, t, a, i, r, n, s, o, l, u, f, c;
          var d = k.elements;
          if ((h = H.loadMode) && M < 8 && (e = d.length)) {
            t = 0;
            N++;
            for (; t < e; t++) {
              if (!d[t] || d[t]._lazyRace) {
                continue;
              }
              if (!E || (k.prematureUnveil && k.prematureUnveil(d[t]))) {
                R(d[t]);
                continue;
              }
              if (!(o = d[t][$]('data-expand')) || !(n = o * 1)) {
                n = w;
              }
              if (!u) {
                u = !H.expand || H.expand < 1 ? (O.clientHeight > 500 && O.clientWidth > 500 ? 500 : 370) : H.expand;
                k._defEx = u;
                f = u * H.expFactor;
                c = H.hFac;
                A = null;
                if (w < f && M < 1 && N > 2 && h > 2 && !D.hidden) {
                  w = f;
                  N = 0;
                } else if (h > 1 && N > 1 && M < 6) {
                  w = u;
                } else {
                  w = _;
                }
              }
              if (l !== n) {
                y = innerWidth + n * c;
                z = innerHeight + n;
                s = n * -1;
                l = n;
              }
              a = d[t].getBoundingClientRect();
              if ((b = a.bottom) >= s && (g = a.top) <= z && (C = a.right) >= s * c && (p = a.left) <= y && (b || C || p || g) && (H.loadHidden || x(d[t])) && ((m && M < 3 && !o && (h < 3 || N < 4)) || W(d[t], n))) {
                R(d[t]);
                r = true;
                if (M > 9) {
                  break;
                }
              } else if (!r && m && !i && M < 4 && N < 4 && h > 2 && (v[0] || H.preloadAfterLoad) && (v[0] || (!o && (b || C || p || g || d[t][$](H.sizesAttr) != 'auto')))) {
                i = v[0] || d[t];
              }
            }
            if (i && !r) {
              R(i);
            }
          }
        };
        var a = ae(t);
        var S = function (e) {
          var t = e.target;
          if (t._lazyCache) {
            delete t._lazyCache;
            return;
          }
          L(e);
          K(t, H.loadedClass);
          Q(t, H.loadingClass);
          V(t, B);
          X(t, 'lazyloaded');
        };
        var i = te(S);
        var B = function (e) {
          i({ target: e.target });
        };
        var T = function (e, t) {
          var a = e.getAttribute('data-load-mode') || H.iframeLoadMode;
          if (a == 0) {
            e.contentWindow.location.replace(t);
          } else if (a == 1) {
            e.src = t;
          }
        };
        var F = function (e) {
          var t;
          var a = e[$](H.srcsetAttr);
          if ((t = H.customMedia[e[$]('data-media') || e[$]('media')])) {
            e.setAttribute('media', t);
          }
          if (a) {
            e.setAttribute('srcset', a);
          }
        };
        var s = te(function (t, e, a, i, r) {
          var n, s, o, l, u, f;
          if (!(u = X(t, 'lazybeforeunveil', e)).defaultPrevented) {
            if (i) {
              if (a) {
                K(t, H.autosizesClass);
              } else {
                t.setAttribute('sizes', i);
              }
            }
            s = t[$](H.srcsetAttr);
            n = t[$](H.srcAttr);
            if (r) {
              o = t.parentNode;
              l = o && j.test(o.nodeName || '');
            }
            f = e.firesLoad || ('src' in t && (s || n || l));
            u = { target: t };
            K(t, H.loadingClass);
            if (f) {
              clearTimeout(c);
              c = I(L, 2500);
              V(t, B, true);
            }
            if (l) {
              G.call(o.getElementsByTagName('source'), F);
            }
            if (s) {
              t.setAttribute('srcset', s);
            } else if (n && !l) {
              if (d.test(t.nodeName)) {
                T(t, n);
              } else {
                t.src = n;
              }
            }
            if (r && (s || l)) {
              Y(t, { src: n });
            }
          }
          if (t._lazyRace) {
            delete t._lazyRace;
          }
          Q(t, H.lazyClass);
          ee(function () {
            var e = t.complete && t.naturalWidth > 1;
            if (!f || e) {
              if (e) {
                K(t, H.fastLoadedClass);
              }
              S(u);
              t._lazyCache = true;
              I(function () {
                if ('_lazyCache' in t) {
                  delete t._lazyCache;
                }
              }, 9);
            }
            if (t.loading == 'lazy') {
              M--;
            }
          }, true);
        });
        var R = function (e) {
          if (e._lazyRace) {
            return;
          }
          var t;
          var a = n.test(e.nodeName);
          var i = a && (e[$](H.sizesAttr) || e[$]('sizes'));
          var r = i == 'auto';
          if ((r || !m) && a && (e[$]('src') || e.srcset) && !e.complete && !J(e, H.errorClass) && J(e, H.lazyClass)) {
            return;
          }
          t = X(e, 'lazyunveilread').detail;
          if (r) {
            re.updateElem(e, true, e.offsetWidth);
          }
          e._lazyRace = true;
          M++;
          s(e, t, r, i, a);
        };
        var r = ie(function () {
          H.loadMode = 3;
          a();
        });
        var o = function () {
          if (H.loadMode == 3) {
            H.loadMode = 2;
          }
          r();
        };
        var l = function () {
          if (m) {
            return;
          }
          if (f.now() - e < 999) {
            I(l, 999);
            return;
          }
          m = true;
          H.loadMode = 3;
          a();
          q('scroll', o, true);
        };
        return {
          _: function () {
            e = f.now();
            k.elements = D.getElementsByClassName(H.lazyClass);
            v = D.getElementsByClassName(H.lazyClass + ' ' + H.preloadClass);
            q('scroll', a, true);
            q('resize', a, true);
            q('pageshow', function (e) {
              if (e.persisted) {
                var t = D.querySelectorAll('.' + H.loadingClass);
                if (t.length && t.forEach) {
                  U(function () {
                    t.forEach(function (e) {
                      if (e.complete) {
                        R(e);
                      }
                    });
                  });
                }
              }
            });
            if (u.MutationObserver) {
              new MutationObserver(a).observe(O, { childList: true, subtree: true, attributes: true });
            } else {
              O[P]('DOMNodeInserted', a, true);
              O[P]('DOMAttrModified', a, true);
              setInterval(a, 999);
            }
            q('hashchange', a, true);
            ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function (e) {
              D[P](e, a, true);
            });
            if (/d$|^c/.test(D.readyState)) {
              l();
            } else {
              q('load', l);
              D[P]('DOMContentLoaded', a);
              I(l, 2e4);
            }
            if (k.elements.length) {
              t();
              ee._lsFlush();
            } else {
              a();
            }
          },
          checkElems: a,
          unveil: R,
          _aLSL: o,
        };
      })(),
      re = (function () {
        var a;
        var n = te(function (e, t, a, i) {
          var r, n, s;
          e._lazysizesWidth = i;
          i += 'px';
          e.setAttribute('sizes', i);
          if (j.test(t.nodeName || '')) {
            r = t.getElementsByTagName('source');
            for (n = 0, s = r.length; n < s; n++) {
              r[n].setAttribute('sizes', i);
            }
          }
          if (!a.detail.dataAttr) {
            Y(e, a.detail);
          }
        });
        var i = function (e, t, a) {
          var i;
          var r = e.parentNode;
          if (r) {
            a = s(e, r, a);
            i = X(e, 'lazybeforesizes', { width: a, dataAttr: !!t });
            if (!i.defaultPrevented) {
              a = i.detail.width;
              if (a && a !== e._lazysizesWidth) {
                n(e, r, i, a);
              }
            }
          }
        };
        var e = function () {
          var e;
          var t = a.length;
          if (t) {
            e = 0;
            for (; e < t; e++) {
              i(a[e]);
            }
          }
        };
        var t = ie(e);
        return {
          _: function () {
            a = D.getElementsByClassName(H.autosizesClass);
            q('resize', t);
          },
          checkElems: t,
          updateElem: i,
        };
      })(),
      t = function () {
        if (!t.i && D.getElementsByClassName) {
          t.i = true;
          re._();
          e._();
        }
      };
    return (
      I(function () {
        H.init && t();
      }),
      (k = { cfg: H, autoSizer: re, loader: e, init: t, uP: Y, aC: K, rC: Q, hC: J, fire: X, gW: s, rAF: ee })
    );
  })(e, e.document, Date);
  (e.lazySizes = t), 'object' == typeof module && module.exports && (module.exports = t);
})('undefined' != typeof window ? window : {});

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

var OverlayScrollbarsGlobal = (function (n) {
  'use strict';
  var r = function (n, r) {
      var t,
        e = n.i,
        i = n.v,
        o = n.o,
        u = e,
        c = function (n, r) {
          var e = u,
            c = n,
            a = r || (i ? !i(e, c) : e !== c);
          return (a || o) && ((u = c), (t = e)), [u, a, t];
        };
      return [
        r
          ? function (n) {
              return c(r(u, t), n);
            }
          : c,
        function (n) {
          return [u, !!n, t];
        },
      ];
    },
    t = 'undefined' != typeof window && 'undefined' != typeof document,
    e = t ? window : {},
    i = Math.max,
    o = Math.min,
    u = Math.round,
    c = Math.abs,
    a = Math.sign,
    f = e.cancelAnimationFrame,
    l = e.requestAnimationFrame,
    s = e.setTimeout,
    v = e.clearTimeout,
    d = function (n) {
      return void 0 !== e[n] ? e[n] : void 0;
    },
    p = d('MutationObserver'),
    y = d('IntersectionObserver'),
    h = d('ResizeObserver'),
    x = d('ScrollTimeline'),
    b = t && Node.ELEMENT_NODE,
    g = Object.prototype,
    m = g.toString,
    w = g.hasOwnProperty,
    O = /^\[object (.+)\]$/,
    S = function (n) {
      return void 0 === n;
    },
    P = function (n) {
      return null === n;
    },
    C = function (n) {
      return 'number' == typeof n;
    },
    D = function (n) {
      return 'string' == typeof n;
    },
    M = function (n) {
      return 'boolean' == typeof n;
    },
    k = function (n) {
      return 'function' == typeof n;
    },
    E = function (n) {
      return Array.isArray(n);
    },
    T = function (n) {
      return 'object' == typeof n && !E(n) && !P(n);
    },
    H = function (n) {
      var r = !!n && n.length,
        t = C(r) && r > -1 && r % 1 == 0;
      return !(!(E(n) || (!k(n) && t)) || (r > 0 && T(n) && !(r - 1 in n)));
    },
    I = function (n) {
      if (
        !n ||
        !T(n) ||
        'object' !==
          (function (n) {
            return S(n) || P(n) ? '' + n : m.call(n).replace(O, '$1').toLowerCase();
          })(n)
      )
        return !1;
      var r,
        t = 'constructor',
        e = n[t],
        i = e && e.prototype,
        o = w.call(n, t),
        u = i && w.call(i, 'isPrototypeOf');
      if (e && !o && !u) return !1;
      for (r in n);
      return S(r) || w.call(n, r);
    },
    A = function (n) {
      var r = HTMLElement;
      return !!n && (r ? n instanceof r : n.nodeType === b);
    },
    L = function (n) {
      var r = Element;
      return !!n && (r ? n instanceof r : n.nodeType === b);
    },
    R = function () {
      return performance.now();
    },
    V = function (n, r, t, e, o) {
      var u = 0,
        c = R(),
        a = i(0, t),
        s = function t(f) {
          var s = R(),
            v = s - c >= a,
            d = f ? 1 : 1 - (i(0, c + a - s) / a || 0),
            p = (r - n) * (k(o) ? o(d, d * a, 0, 1, a) : d) + n,
            y = v || 1 === d;
          e && e(p, d, y),
            (u = y
              ? 0
              : l(function () {
                  return t();
                }));
        };
      return (
        s(),
        function (n) {
          f(u), n && s(n);
        }
      );
    };
  function _(n, r) {
    if (H(n)) for (var t = 0; t < n.length && !1 !== r(n[t], t, n); t++);
    else
      n &&
        _(Object.keys(n), function (t) {
          return r(n[t], t, n);
        });
    return n;
  }
  var j = function (n, r) {
      return n.indexOf(r) >= 0;
    },
    z = function (n, r) {
      return n.concat(r);
    },
    $ = function (n, r, t) {
      return t || D(r) || !H(r) ? n.push(r) : Array.prototype.push.apply(n, r), n;
    },
    N = function (n) {
      return Array.from(n || []);
    },
    F = function (n) {
      return E(n) ? n : [n];
    },
    B = function (n) {
      return !!n && !n.length;
    },
    W = function (n) {
      return N(new Set(n));
    },
    Y = function (n, r, t) {
      _(n, function (n) {
        return n && n.apply(void 0, r || []);
      }),
        !t && (n.length = 0);
    },
    J = 'paddingTop',
    X = 'paddingRight',
    q = 'paddingLeft',
    G = 'paddingBottom',
    K = 'marginLeft',
    U = 'marginRight',
    Q = 'marginBottom',
    Z = 'overflowX',
    nn = 'overflowY',
    rn = 'width',
    tn = 'height',
    en = 'visible',
    on = 'hidden',
    un = 'scroll',
    cn = function (n, r, t, e) {
      if (n && r) {
        var i = !0;
        return (
          _(t, function (t) {
            (e ? e(n[t]) : n[t]) !== (e ? e(r[t]) : r[t]) && (i = !1);
          }),
          i
        );
      }
      return !1;
    },
    an = function (n, r) {
      return cn(n, r, ['w', 'h']);
    },
    fn = function (n, r) {
      return cn(n, r, ['x', 'y']);
    },
    ln = function (n, r) {
      return cn(n, r, ['t', 'r', 'b', 'l']);
    },
    sn = function () {},
    vn = function (n) {
      for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++) t[e - 1] = arguments[e];
      return n.bind.apply(n, [0].concat(t));
    },
    dn = function (n) {
      var r,
        t = n ? s : l,
        e = n ? v : f;
      return [
        function (i) {
          e(r), (r = t(i, k(n) ? n() : n));
        },
        function () {
          return e(r);
        },
      ];
    },
    pn = function (n, r) {
      var t,
        e,
        i,
        o = sn,
        u = r || {},
        c = u.u,
        a = u.p,
        d = u._,
        p = function (r) {
          o(), v(t), (t = e = void 0), (o = sn), n.apply(this, r);
        },
        y = function (n) {
          return d && e ? d(e, n) : n;
        },
        h = function () {
          o !== sn && p(y(i) || i);
        },
        x = function () {
          var n = N(arguments),
            r = k(c) ? c() : c;
          if (C(r) && r >= 0) {
            var u = k(a) ? a() : a,
              d = C(u) && u >= 0,
              x = r > 0 ? s : l,
              b = r > 0 ? v : f,
              g = y(n) || n,
              m = p.bind(0, g);
            o();
            var w = x(m, r);
            (o = function () {
              return b(w);
            }),
              d && !t && (t = s(h, u)),
              (e = i = g);
          } else p(n);
        };
      return (x.m = h), x;
    },
    yn = function (n, r) {
      return Object.prototype.hasOwnProperty.call(n, r);
    },
    hn = function (n) {
      return n ? Object.keys(n) : [];
    },
    xn = function n(r, t, e, i, o, u, c) {
      var a = [t, e, i, o, u, c];
      return (
        ('object' == typeof r && !P(r)) || k(r) || (r = {}),
        _(a, function (t) {
          _(t, function (e, i) {
            var o = t[i];
            if (r === o) return !0;
            var u = E(o);
            if (o && I(o)) {
              var c = r[i],
                a = c;
              u && !E(c) ? (a = []) : u || I(c) || (a = {}), (r[i] = n(a, o));
            } else r[i] = u ? o.slice() : o;
          });
        }),
        r
      );
    },
    bn = function n(r, t) {
      return _(xn({}, r), function (r, e, i) {
        void 0 === r ? delete i[e] : t && r && I(r) && (i[e] = n(r, t));
      });
    },
    gn = function (n) {
      for (var r in n) return !1;
      return !0;
    },
    mn = function (n, r, t) {
      return i(n, o(r, t));
    },
    wn = function (n) {
      return N(
        new Set(
          (E(n) ? n : (n || '').split(' ')).filter(function (n) {
            return n;
          })
        )
      );
    },
    On = function (n, r) {
      return n && n.getAttribute(r);
    },
    Sn = function (n, r) {
      return n && n.hasAttribute(r);
    },
    Pn = function (n, r, t) {
      _(wn(r), function (r) {
        n && n.setAttribute(r, String(t || ''));
      });
    },
    Cn = function (n, r) {
      _(wn(r), function (r) {
        return n && n.removeAttribute(r);
      });
    },
    Dn = function (n, r) {
      var t = wn(On(n, r)),
        e = vn(Pn, n, r),
        i = function (n, r) {
          var e = new Set(t);
          return (
            _(wn(n), function (n) {
              e[r](n);
            }),
            N(e).join(' ')
          );
        };
      return {
        S: function (n) {
          return e(i(n, 'delete'));
        },
        O: function (n) {
          return e(i(n, 'add'));
        },
        C: function (n) {
          var r = wn(n);
          return r.reduce(function (n, r) {
            return n && t.includes(r);
          }, r.length > 0);
        },
      };
    },
    Mn = function (n, r, t) {
      return Dn(n, r).S(t), vn(kn, n, r, t);
    },
    kn = function (n, r, t) {
      return Dn(n, r).O(t), vn(Mn, n, r, t);
    },
    En = function (n, r, t, e) {
      return (e ? kn : Mn)(n, r, t);
    },
    Tn = function (n) {
      return Dn(n, 'class');
    },
    Hn = function (n, r) {
      Tn(n).S(r);
    },
    In = function (n, r) {
      return Tn(n).O(r), vn(Hn, n, r);
    },
    An = function (n, r) {
      var t = [],
        e = r ? L(r) && r : document;
      return e ? $(t, e.querySelectorAll(n)) : t;
    },
    Ln = function (n, r) {
      return !!L(n) && n.matches(r);
    },
    Rn = function (n) {
      return Ln(n, 'body');
    },
    Vn = function (n) {
      return n ? N(n.childNodes) : [];
    },
    _n = function (n) {
      return n && n.parentElement;
    },
    jn = function (n, r) {
      return L(n) && n.closest(r);
    },
    zn = function (n) {
      return (n || document).activeElement;
    },
    $n = function (n, r, t) {
      var e = jn(n, r),
        i =
          n &&
          (function (n, r) {
            var t = r ? L(r) && r : document;
            return t ? t.querySelector(n) : null;
          })(t, e),
        o = jn(i, r) === e;
      return !(!e || !i) && (e === n || i === n || (o && jn(jn(n, t), r) !== e));
    },
    Nn = function n(r) {
      if (H(r))
        _(N(r), function (r) {
          return n(r);
        });
      else if (r) {
        var t = _n(r);
        t && t.removeChild(r);
      }
    },
    Fn = function (n, r, t) {
      if (t && n) {
        var e,
          i = r;
        return (
          H(t)
            ? ((e = document.createDocumentFragment()),
              _(t, function (n) {
                n === i && (i = n.previousSibling), e.appendChild(n);
              }))
            : (e = t),
          r && (i ? i !== r && (i = i.nextSibling) : (i = n.firstChild)),
          n.insertBefore(e, i || null),
          function () {
            return Nn(t);
          }
        );
      }
      return sn;
    },
    Bn = function (n, r) {
      return Fn(n, null, r);
    },
    Wn = function (n, r) {
      return Fn(_n(n), n && n.nextSibling, r);
    },
    Yn = function (n) {
      var r = document.createElement('div');
      return Pn(r, 'class', n), r;
    },
    Jn = function (n) {
      var r = Yn();
      return (
        (r.innerHTML = n.trim()),
        _(Vn(r), function (n) {
          return Nn(n);
        })
      );
    },
    Xn = /^--/,
    qn = function (n, r) {
      return n.getPropertyValue(r) || n[r] || '';
    },
    Gn = function (n) {
      var r = n || 0;
      return isFinite(r) ? r : 0;
    },
    Kn = function (n) {
      return Gn(parseFloat(n || ''));
    },
    Un = function (n) {
      return (100 * Gn(n)).toFixed(3) + '%';
    },
    Qn = function (n) {
      return Gn(n) + 'px';
    };
  function Zn(n, r) {
    n &&
      r &&
      _(r, function (r, t) {
        try {
          var e = n.style,
            i = C(r) ? Qn(r) : (r || '') + '';
          Xn.test(t) ? e.setProperty(t, i) : (e[t] = i);
        } catch (o) {}
      });
  }
  function nr(n, r, t) {
    var i = D(r),
      o = i ? '' : {};
    if (n) {
      var u = e.getComputedStyle(n, t) || n.style;
      o = i
        ? qn(u, r)
        : N(r).reduce(function (n, r) {
            return (n[r] = qn(u, r)), n;
          }, o);
    }
    return o;
  }
  var rr,
    tr = function (n, r, t) {
      var e = r ? r + '-' : '',
        i = t ? '-' + t : '',
        o = e + 'top' + i,
        u = e + 'right' + i,
        c = e + 'bottom' + i,
        a = e + 'left' + i,
        f = nr(n, [o, u, c, a]);
      return { t: Kn(f[o]), r: Kn(f[u]), b: Kn(f[c]), l: Kn(f[a]) };
    },
    er = function (n, r) {
      return 'translate' + (T(n) ? '(' + n.x + ',' + n.y + ')' : (r ? 'X' : 'Y') + '(' + n + ')');
    },
    ir = { w: 0, h: 0 },
    or = function (n, r) {
      return r ? { w: r[n + 'Width'], h: r[n + 'Height'] } : ir;
    },
    ur = function (n) {
      return or('inner', n || e);
    },
    cr = vn(or, 'offset'),
    ar = vn(or, 'client'),
    fr = vn(or, 'scroll'),
    lr = function (n) {
      var r = parseFloat(nr(n, rn)) || 0,
        t = parseFloat(nr(n, tn)) || 0;
      return { w: r - u(r), h: t - u(t) };
    },
    sr = function (n) {
      return n.getBoundingClientRect();
    },
    vr = function (n) {
      return !(!n || (!n[tn] && !n[rn]));
    },
    dr = function (n, r) {
      var t = vr(n);
      return !vr(r) && t;
    },
    pr = function (n, r, t, e) {
      _(wn(r), function (r) {
        n && n.removeEventListener(r, t, e);
      });
    },
    yr = function (n, r, t, e) {
      var i,
        o = null == (i = e && e.A) || i,
        u = (e && e.H) || !1,
        c = (e && e.T) || !1,
        a = { passive: o, capture: u };
      return vn(
        Y,
        wn(r).map(function (r) {
          var e = c
            ? function (i) {
                pr(n, r, e, u), t && t(i);
              }
            : t;
          return n && n.addEventListener(r, e, a), vn(pr, n, r, e, u);
        })
      );
    },
    hr = function (n) {
      return n.stopPropagation();
    },
    xr = function (n) {
      return n.preventDefault();
    },
    br = function (n) {
      return hr(n) || xr(n);
    },
    gr = function (n, r) {
      var t = C(r) ? { x: r, y: r } : r || {},
        e = t.x,
        i = t.y;
      C(e) && (n.scrollLeft = e), C(i) && (n.scrollTop = i);
    },
    mr = function (n) {
      return { x: n.scrollLeft, y: n.scrollTop };
    },
    wr = function (n, r) {
      var t = n.P,
        e = n.D,
        i = r.w,
        o = r.h,
        u = function (n, r, t) {
          var e = a(n) * t,
            i = a(r) * t;
          if (e === i) {
            var o = c(n),
              u = c(r);
            (i = o > u ? 0 : i), (e = o < u ? 0 : e);
          }
          return [e + 0, i + 0];
        },
        f = u(t.x, e.x, i),
        l = f[0],
        s = f[1],
        v = u(t.y, e.y, o);
      return { P: { x: l, y: v[0] }, D: { x: s, y: v[1] } };
    },
    Or = function (n) {
      var r = n.P,
        t = n.D,
        e = function (n, r) {
          return 0 === n && n <= r;
        };
      return { x: e(r.x, t.x), y: e(r.y, t.y) };
    },
    Sr = function (n, r) {
      var t = n.P,
        e = n.D,
        i = function (n, r, t) {
          return mn(0, 1, (n - t) / (n - r) || 0);
        };
      return { x: i(t.x, e.x, r.x), y: i(t.y, e.y, r.y) };
    },
    Pr = function (n, r) {
      _(F(r), n);
    },
    Cr = function (n) {
      var r = new Map(),
        t = function (n, t) {
          if (n) {
            var e = r.get(n);
            Pr(function (n) {
              e && e[n ? 'delete' : 'clear'](n);
            }, t);
          } else
            r.forEach(function (n) {
              n.clear();
            }),
              r.clear();
        },
        e = function n(e, i) {
          if (D(e)) {
            var o = r.get(e) || new Set();
            return (
              r.set(e, o),
              Pr(function (n) {
                k(n) && o.add(n);
              }, i),
              vn(t, e, i)
            );
          }
          M(i) && i && t();
          var u = hn(e),
            c = [];
          return (
            _(u, function (r) {
              var t = e[r];
              t && $(c, n(r, t));
            }),
            vn(Y, c)
          );
        };
      return (
        e(n || {}),
        [
          e,
          t,
          function (n, t) {
            _(N(r.get(n)), function (n) {
              t && !B(t) ? n.apply(0, t) : n();
            });
          },
        ]
      );
    },
    Dr = function (n) {
      return JSON.stringify(n, function (n, r) {
        if (k(r)) throw 0;
        return r;
      });
    },
    Mr = function (n, r) {
      return n
        ? ('' + r).split('.').reduce(function (n, r) {
            return n && yn(n, r) ? n[r] : void 0;
          }, n)
        : void 0;
    },
    kr = {
      paddingAbsolute: !1,
      showNativeOverlaidScrollbars: !1,
      update: { elementEvents: [['img', 'load']], debounce: [0, 33], attributes: null, ignoreMutation: null },
      overflow: { x: 'scroll', y: 'scroll' },
      scrollbars: { theme: 'os-theme-dark', visibility: 'auto', autoHide: 'never', autoHideDelay: 1300, autoHideSuspend: !1, dragScroll: !0, clickScroll: !1, pointers: ['mouse', 'touch', 'pen'] },
    },
    Er = function n(r, t) {
      var e = {};
      return (
        _(z(hn(t), hn(r)), function (i) {
          var o = r[i],
            u = t[i];
          if (T(o) && T(u)) xn((e[i] = {}), n(o, u)), gn(e[i]) && delete e[i];
          else if (yn(t, i) && u !== o) {
            var a = !0;
            if (E(o) || E(u))
              try {
                Dr(o) === Dr(u) && (a = !1);
              } catch (c) {}
            a && (e[i] = u);
          }
        }),
        e
      );
    },
    Tr = function (n, r, t) {
      return function (e) {
        return [Mr(n, e), t || void 0 !== Mr(r, e)];
      };
    },
    Hr = 'data-overlayscrollbars',
    Ir = 'os-environment',
    Ar = Ir + '-scrollbar-hidden',
    Lr = Hr + '-initialize',
    Rr = 'noClipping',
    Vr = Hr + '-body',
    _r = Hr,
    jr = 'host',
    zr = Hr + '-viewport',
    $r = Z,
    Nr = nn,
    Fr = 'arrange',
    Br = 'measuring',
    Wr = 'scrollbarHidden',
    Yr = 'scrollbarPressed',
    Jr = 'noContent',
    Xr = Hr + '-padding',
    qr = Hr + '-content',
    Gr = 'os-size-observer',
    Kr = Gr + '-appear',
    Ur = Gr + '-listener',
    Qr = Ur + '-scroll',
    Zr = Ur + '-item',
    nt = Zr + '-final',
    rt = 'os-trinsic-observer',
    tt = 'os-theme-none',
    et = 'os-scrollbar',
    it = et + '-rtl',
    ot = et + '-horizontal',
    ut = et + '-vertical',
    ct = et + '-track',
    at = et + '-handle',
    ft = et + '-visible',
    lt = et + '-cornerless',
    st = et + '-interaction',
    vt = et + '-unusable',
    dt = et + '-auto-hide',
    pt = dt + '-hidden',
    yt = et + '-wheel',
    ht = ct + '-interactive',
    xt = at + '-interactive',
    bt = function () {
      return (
        rr ||
          (rr = (function () {
            var n = function (n, r, t) {
                Bn(document.body, n), Bn(document.body, n);
                var e = ar(n),
                  i = cr(n),
                  o = lr(r);
                return t && Nn(n), { x: i.h - e.h + o.h, y: i.w - e.w + o.w };
              },
              t = Jn(
                '<div class="' +
                  Ir +
                  '"><div></div><style>' +
                  '.' +
                  Ir +
                  '{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.' +
                  Ir +
                  ' div{width:200%;height:200%;margin:10px 0}.' +
                  Ar +
                  '{scrollbar-width:none!important}.' +
                  Ar +
                  '::-webkit-scrollbar,.' +
                  Ar +
                  '::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}' +
                  '</style></div>'
              )[0],
              i = t.firstChild,
              o = Cr(),
              u = o[0],
              c = o[2],
              a = r({ i: n(t, i), v: fn }, vn(n, t, i, !0)),
              f = a[0],
              l = (0, a[1])()[0],
              s = (function (n) {
                var r = !1,
                  t = In(n, Ar);
                try {
                  r = 'none' === nr(n, 'scrollbar-width') || 'none' === nr(n, 'display', '::-webkit-scrollbar');
                } catch (e) {}
                return t(), r;
              })(t),
              v = { x: 0 === l.x, y: 0 === l.y },
              d = {
                elements: {
                  host: null,
                  padding: !s,
                  viewport: function (n) {
                    return s && Rn(n) && n;
                  },
                  content: !1,
                },
                scrollbars: { slot: !0 },
                cancel: { nativeScrollbarsOverlaid: !1, body: null },
              },
              p = xn({}, kr),
              y = vn(xn, {}, p),
              h = vn(xn, {}, d),
              b = {
                L: l,
                k: v,
                I: s,
                M: !!x,
                R: vn(u, 'r'),
                V: h,
                F: function (n) {
                  return xn(d, n) && h();
                },
                j: y,
                N: function (n) {
                  return xn(p, n) && y();
                },
                U: xn({}, d),
                q: xn({}, p),
              };
            return (
              Cn(t, 'style'),
              Nn(t),
              yr(e, 'resize', function () {
                c('r', []);
              }),
              !k(e.matchMedia) ||
                s ||
                (v.x && v.y) ||
                (function n(r) {
                  var t = e.matchMedia('(resolution: ' + e.devicePixelRatio + 'dppx)');
                  yr(
                    t,
                    'change',
                    function () {
                      r(), n(r);
                    },
                    { T: !0 }
                  );
                })(function () {
                  var n = f(),
                    r = n[0],
                    t = n[1];
                  xn(b.L, r), c('r', [t]);
                }),
              b
            );
          })()),
        rr
      );
    },
    gt = function (n, r) {
      return k(r) ? r.apply(0, n) : r;
    },
    mt = function (n, r, t, e) {
      var i = S(e) ? t : e;
      return gt(n, i) || r.apply(0, n);
    },
    wt = function (n, r, t, e) {
      var i = S(e) ? t : e,
        o = gt(n, i);
      return !!o && (A(o) ? o : r.apply(0, n));
    },
    Ot = function (n, r) {
      var t = r || {},
        e = t.nativeScrollbarsOverlaid,
        i = t.body,
        o = bt(),
        u = o.k,
        c = o.I,
        a = (0, o.V)().cancel,
        f = a.nativeScrollbarsOverlaid,
        l = a.body,
        s = null != e ? e : f,
        v = S(i) ? l : i,
        d = (u.x || u.y) && s,
        p = n && (P(v) ? !c : v);
      return !!d || !!p;
    },
    St = new WeakMap(),
    Pt = function (n) {
      return St.get(n);
    },
    Ct = function (n, r, t, e) {
      var i = !1,
        o = e || {},
        u = o.B,
        c = o.Y,
        a = o.W,
        f = o.X,
        l = o.Z,
        s = o.K,
        v = pn(
          function () {
            return i && t(!0);
          },
          { u: 33, p: 99 }
        ),
        d = (function (n, r, t) {
          var e = !1,
            i = !!t && new WeakMap(),
            o = function (o) {
              if (i && t) {
                var u = t.map(function (r) {
                  var t = r || [],
                    e = t[0],
                    i = t[1];
                  return [i && e ? (o || An)(e, n) : [], i];
                });
                _(u, function (t) {
                  return _(t[0], function (o) {
                    var u = t[1],
                      c = i.get(o) || [];
                    if (n.contains(o) && u) {
                      var a = yr(o, u, function (n) {
                        e ? (a(), i.delete(o)) : r(n);
                      });
                      i.set(o, $(c, a));
                    } else Y(c), i.delete(o);
                  });
                });
              }
            };
          return (
            o(),
            [
              function () {
                e = !0;
              },
              o,
            ]
          );
        })(n, v, a),
        y = d[0],
        h = d[1],
        x = c || [],
        b = z(u || [], x),
        g = function (i, o) {
          if (!B(o)) {
            var u = l || sn,
              c = s || sn,
              a = [],
              v = [],
              d = !1,
              p = !1;
            if (
              (_(o, function (t) {
                var i = t.attributeName,
                  o = t.target,
                  l = t.type,
                  s = t.oldValue,
                  y = t.addedNodes,
                  h = t.removedNodes,
                  b = 'attributes' === l,
                  g = 'childList' === l,
                  m = n === o,
                  w = b && i,
                  O = (w && On(o, i || '')) || null,
                  S = w && s !== O,
                  P = j(x, i) && S;
                if (r && (g || !m)) {
                  var C = b && S,
                    D = C && f && Ln(o, f),
                    M = (D ? !u(o, i, s, O) : !b || C) && !c(t, !!D, n, e);
                  _(y, function (n) {
                    return $(a, n);
                  }),
                    _(h, function (n) {
                      return $(a, n);
                    }),
                    (p = p || M);
                }
                !r && m && S && !u(o, i, s, O) && ($(v, i), (d = d || P));
              }),
              h(function (n) {
                return W(a).reduce(function (r, t) {
                  return $(r, An(n, t)), Ln(t, n) ? $(r, t) : r;
                }, []);
              }),
              r)
            )
              return !i && p && t(!1), [!1];
            if (!B(v) || d) {
              var y = [W(v), d];
              return !i && t.apply(0, y), y;
            }
          }
        },
        m = new p(vn(g, !1));
      return [
        function () {
          return (
            m.observe(n, { attributes: !0, attributeOldValue: !0, attributeFilter: b, subtree: r, childList: r, characterData: r }),
            (i = !0),
            function () {
              i && (y(), m.disconnect(), (i = !1));
            }
          );
        },
        function () {
          if (i) return v.m(), g(!0, m.takeRecords());
        },
      ];
    },
    Dt = {},
    Mt = {},
    kt = function (n, r, t) {
      return hn(n).map(function (e) {
        var i = n[e],
          o = i.static,
          u = i.instance,
          c = t || [],
          a = c[0],
          f = c[1],
          l = c[2],
          s = t ? u : o;
        if (s) {
          var v = t ? s(a, f, r) : s(r);
          return ((l || Mt)[e] = v);
        }
      });
    },
    Et = function (n) {
      return Mt[n];
    };
  !(function (n) {
    function r() {
      return (
        (n.exports = r =
          Object.assign
            ? Object.assign.bind()
            : function (n) {
                for (var r = 1; r < arguments.length; r++) {
                  var t = arguments[r];
                  for (var e in t) Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
                }
                return n;
              }),
        (n.exports.G = !0),
        (n.exports['default'] = n.exports),
        r.apply(this, arguments)
      );
    }
    (n.exports = r), (n.exports.G = !0), (n.exports['default'] = n.exports);
  })({ exports: {} });
  var Tt = '__osOptionsValidationPlugin',
    Ht = '__osSizeObserverPlugin',
    It = (function (n) {
      return (
        ((n = {})[Ht] = {
          static: function () {
            return function (n, r, t) {
              var e,
                i,
                o = 3333333,
                u = 'scroll',
                c = Jn('<div class="' + Zr + '" dir="ltr"><div class="' + Zr + '"><div class="' + nt + '"></div></div><div class="' + Zr + '"><div class="' + nt + '" style="width: 200%; height: 200%"></div></div></div>'),
                a = c[0],
                s = a.lastChild,
                v = a.firstChild,
                d = null == v ? void 0 : v.firstChild,
                p = cr(a),
                y = p,
                h = !1,
                x = function () {
                  gr(v, o), gr(s, o);
                },
                b = function (n) {
                  (i = 0), h && ((p = y), r(!0 === n));
                },
                g = function (n) {
                  (y = cr(a)), (h = !n || !an(y, p)), n ? (hr(n), h && !i && (f(i), (i = l(b)))) : b(!1 === n), x();
                },
                m = [Bn(n, c), yr(v, u, g), yr(s, u, g)];
              return In(n, Qr), Zn(d, (((e = {})[rn] = o), (e[tn] = o), e)), l(x), [t ? vn(g, !1) : x, m];
            };
          },
        }),
        n
      );
    })(),
    At = function (n, r) {
      var t = r.k,
        e = n('showNativeOverlaidScrollbars'),
        i = e[0],
        o = e[1];
      return [i && t.x && t.y, o];
    },
    Lt = function (n) {
      return 0 === n.indexOf(en);
    },
    Rt = function (n, r) {
      var t = function (n, r, t, e) {
          var i = n === en ? on : n.replace(en + '-', ''),
            o = Lt(n),
            u = Lt(t);
          return r || e ? (o && u ? en : o ? (r && e ? i : r ? en : on) : r ? i : u && e ? en : on) : on;
        },
        e = { x: t(r.x, n.x, r.y, n.y), y: t(r.y, n.y, r.x, n.x) };
      return { $: e, J: { x: e.x === un, y: e.y === un } };
    },
    Vt = '__osScrollbarsHidingPlugin',
    _t = (function (n) {
      return (
        ((n = {})[Vt] = {
          static: function () {
            return {
              rr: function (n, r, t, e, i) {
                var o = n.ar,
                  u = n.er,
                  c = e.I,
                  a = e.k,
                  f = e.L,
                  l = !o && !c && (a.x || a.y),
                  s = At(i, e)[0],
                  v = function (n) {
                    var r = n.J,
                      t = c || s ? 0 : 42,
                      e = function (n, r, e) {
                        return [r && !c ? (n ? t : e) : 0, n && !!t];
                      },
                      i = e(a.x, r.x, f.x),
                      o = i[0],
                      u = i[1],
                      l = e(a.y, r.y, f.y);
                    return { tr: { x: o, y: l[0] }, nr: { x: u, y: l[1] } };
                  },
                  d = function (n, t, e) {
                    var i = t.ir;
                    if (!o) {
                      var u,
                        c = xn({}, (((u = {})[U] = 0), (u[Q] = 0), (u[K] = 0), u)),
                        a = v(n),
                        f = a.tr,
                        l = a.nr,
                        s = l.x,
                        d = l.y,
                        p = f.x,
                        y = f.y,
                        h = r.vr,
                        x = i ? K : U,
                        b = i ? q : X,
                        g = h[x],
                        m = h[Q],
                        w = h[b],
                        O = h[G];
                      return (c[rn] = 'calc(100% + ' + (y + -1 * g) + 'px)'), (c[x] = -y + g), (c[Q] = -p + m), e && ((c[b] = w + (d ? y : 0)), (c[G] = O + (s ? p : 0))), c;
                    }
                  };
                return {
                  ur: v,
                  cr: function (n, e, i) {
                    if (l) {
                      var o = r.vr,
                        c = v(n),
                        a = c.tr,
                        f = c.nr,
                        s = f.x,
                        d = f.y,
                        p = a.x,
                        y = a.y,
                        h = o[t.ir ? X : q],
                        x = o.paddingTop,
                        b = e.w + i.w,
                        g = e.h + i.h,
                        m = { w: y && d ? y + b - h + 'px' : '', h: p && s ? p + g - x + 'px' : '' };
                      Zn(u, { '--os-vaw': m.w, '--os-vah': m.h });
                    }
                    return l;
                  },
                  lr: function (n) {
                    if (l) {
                      var e =
                          n ||
                          (function () {
                            var n = function (n) {
                                var r = nr(u, n);
                                return [r, r === un];
                              },
                              r = n(Z),
                              t = r[0],
                              e = r[1],
                              i = n(nn);
                            return { $: { x: t, y: i[0] }, J: { x: e, y: i[1] } };
                          })(),
                        i = r.vr,
                        o = v(e).nr,
                        c = o.x,
                        a = o.y,
                        f = {},
                        s = function (n) {
                          return _(n, function (n) {
                            f[n] = i[n];
                          });
                        };
                      c && s([Q, J, G]), a && s([K, U, q, X]);
                      var p = nr(u, hn(f)),
                        y = Mn(u, zr, Fr);
                      return (
                        Zn(u, f),
                        [
                          function () {
                            Zn(u, xn({}, p, d(e, t, l))), y();
                          },
                          e,
                        ]
                      );
                    }
                    return [sn];
                  },
                  sr: d,
                };
              },
            };
          },
        }),
        n
      );
    })(),
    jt = '__osClickScrollPlugin',
    zt = (function (n) {
      return (
        ((n = {})[jt] = {
          static: function () {
            return function (n, r, t, e, i) {
              var o = 0,
                u = sn;
              return (
                (function c(a) {
                  u = V(a, a + e * Math.sign(t), 133, function (t, a, f) {
                    n(t);
                    var l = r();
                    if (f && !(i >= l && i <= l + e)) {
                      if (o) c(t);
                      else {
                        var v = s(function () {
                          c(t);
                        }, 222);
                        u = function () {
                          clearTimeout(v);
                        };
                      }
                      o++;
                    }
                  });
                })(0),
                function () {
                  return u();
                }
              );
            };
          },
        }),
        n
      );
    })(),
    $t = function (n, t, e) {
      var i = (e || {}).dr,
        o = Et(Ht),
        u = r({ i: !1, o: !0 })[0];
      return function () {
        var r = [],
          e = Jn('<div class="' + Gr + '"><div class="' + Ur + '"></div></div>')[0],
          c = e.firstChild,
          a = function (n) {
            var r = !1,
              e = !1;
            if (n instanceof ResizeObserverEntry) {
              var i = u(n.contentRect),
                o = i[0],
                c = i[2],
                a = vr(o);
              r = !(e = dr(o, c)) && !a;
            } else e = !0 === n;
            r || t({ pr: !0, dr: e });
          };
        if (h) {
          var f = new h(function (n) {
            return a(n.pop());
          });
          f.observe(c),
            $(r, function () {
              f.disconnect();
            });
        } else {
          if (!o) return sn;
          var l = o(c, a, i),
            s = l[0],
            v = l[1];
          $(r, z([In(e, Kr), yr(e, 'animationstart', s)], v));
        }
        return vn(Y, $(r, Bn(n, e)));
      };
    },
    Nt = function (n, t) {
      var e,
        i = Yn(rt),
        o = r({ i: !1 })[0],
        u = function (n, r) {
          if (n) {
            var e = o(
              (function (n) {
                return 0 === n.h || n.isIntersecting || n.intersectionRatio > 0;
              })(n)
            );
            return e[1] && !r && t(e) && [e];
          }
        },
        c = function (n, r) {
          return u(r.pop(), n);
        };
      return [
        function () {
          var r = [];
          if (y)
            (e = new y(vn(c, !1), { root: n })).observe(i),
              $(r, function () {
                e.disconnect();
              });
          else {
            var t = function () {
              var n = cr(i);
              u(n);
            };
            $(r, $t(i, t)()), t();
          }
          return vn(Y, $(r, Bn(n, i)));
        },
        function () {
          return e && c(!0, e.takeRecords());
        },
      ];
    },
    Ft = function (n, t, e, i) {
      var o,
        u,
        c,
        a,
        f,
        l,
        s = bt().I,
        v = '[' + _r + ']',
        d = '[' + zr + ']',
        p = ['tabindex'],
        y = ['wrap', 'cols', 'rows'],
        x = ['id', 'class', 'style', 'open'],
        b = n._r,
        g = n.gr,
        m = n.er,
        w = n.hr,
        O = n.mr,
        S = n.br,
        P = n.ar,
        M = n.Sr,
        T = n.yr,
        H = function (n) {
          return 'rtl' === nr(n, 'direction');
        },
        I = { wr: !1, ir: H(b) },
        A = bt(),
        L = Et(Vt),
        R = r({ v: an, i: { w: 0, h: 0 } }, function () {
          var r = L && L.rr(n, t, I, A, e).lr,
            i = !P && M(Fr),
            o = i && mr(w),
            u = T(Br, !0),
            c = i && r && r()[0],
            a = fr(O),
            f = fr(m),
            l = lr(m);
          return c && c(), gr(w, o), u(), { w: f.w + a.w + l.w, h: f.h + a.h + l.h };
        }),
        V = R[0],
        $ = S ? y : z(x, y),
        N = pn(i, {
          u: function () {
            return o;
          },
          p: function () {
            return u;
          },
          _: function (n, r) {
            var t = n[0],
              e = r[0];
            return [
              z(hn(t), hn(e)).reduce(function (n, r) {
                return (n[r] = t[r] || e[r]), n;
              }, {}),
            ];
          },
        }),
        F = function (n) {
          var r = H(b);
          xn(n, { Or: l !== r }), xn(I, { ir: r }), (l = r);
        },
        B = function (n) {
          _(n || p, function (n) {
            if (j(p, n)) {
              var r = On(g, n);
              D(r) ? Pn(m, n, r) : Cn(m, n);
            }
          });
        },
        W = function (n, r) {
          var t = n[0],
            e = { Cr: n[1] };
          return xn(I, { wr: t }), !r && i(e), e;
        },
        Y = function (n) {
          var r = n.pr,
            t = n.dr,
            e = (r && !t) || !s ? i : N,
            o = { pr: r || t, dr: t };
          F(o), e(o);
        },
        J = function (n, r) {
          var t = V()[1],
            e = { Er: t };
          return F(e), t && !r && (n ? i : N)(e), e;
        },
        X = function (n, r, t) {
          var e = { Ar: r };
          return F(e), r && !t ? N(e) : P || B(n), e;
        },
        q = A.R,
        G = O ? Nt(g, W) : [],
        K = G[0],
        U = G[1],
        Q = !P && $t(g, Y, { dr: !0 }),
        Z = Ct(g, !1, X, { Y: x, B: z(x, p) }),
        nn = Z[0],
        rn = Z[1],
        tn =
          P &&
          h &&
          new h(function (n) {
            var r = n[n.length - 1].contentRect;
            Y({ pr: !0, dr: dr(r, f) }), (f = r);
          });
      return [
        function () {
          B(), tn && tn.observe(g);
          var n = Q && Q(),
            r = K && K(),
            t = nn(),
            e = q(function (n) {
              var r = V()[1];
              N({ Hr: n, Er: r });
            });
          return function () {
            tn && tn.disconnect(), n && n(), r && r(), a && a(), t(), e();
          };
        },
        function (n) {
          var r = n.Tr,
            t = n.Pr,
            e = n.Dr,
            i = {},
            f = r('update.ignoreMutation')[0],
            l = r('update.attributes'),
            s = l[0],
            p = l[1],
            y = r('update.elementEvents'),
            h = y[0],
            x = y[1],
            b = r('update.debounce'),
            g = b[0],
            w = b[1],
            S = t || e;
          if (x || p) {
            c && c(), a && a();
            var D = Ct(O || m, !0, J, {
                B: z($, s || []),
                W: h,
                X: v,
                K: function (n, r) {
                  var t = n.target,
                    e = n.attributeName;
                  return (
                    (!(r || !e || P) && $n(t, v, d)) ||
                    !!jn(t, '.' + et) ||
                    !!(function (n) {
                      return k(f) && f(n);
                    })(n)
                  );
                },
              }),
              M = D[0],
              T = D[1];
            (a = M()), (c = T);
          }
          if (w)
            if ((N.m(), E(g))) {
              var H = g[0],
                I = g[1];
              (o = C(H) && H), (u = C(I) && I);
            } else C(g) ? ((o = g), (u = !1)) : ((o = !1), (u = !1));
          if (S) {
            var A = rn(),
              L = U && U(),
              R = c && c();
            A && xn(i, X(A[0], A[1], S)), L && xn(i, W(L[0], S)), R && xn(i, J(R[0], S));
          }
          return F(i), i;
        },
        I,
      ];
    },
    Bt = function (n, r, t, e) {
      var i = (0, bt().V)().scrollbars.slot,
        o = r._r,
        u = r.gr,
        c = r.er,
        a = r.zr,
        f = r.hr,
        l = r.Lr,
        s = r.ar,
        v = ((a ? {} : n).scrollbars || {}).slot,
        d = new Map(),
        p = function (n) {
          return x && new x({ source: f, axis: n });
        },
        y = { x: p('x'), y: p('y') },
        h = wt(
          [o, u, c],
          function () {
            return s && l ? o : u;
          },
          i,
          v
        ),
        b = function (n, r) {
          if (r) {
            var e = n ? rn : tn,
              i = r.kr,
              o = r.Ir,
              u = sr(o)[e],
              c = sr(i)[e];
            return mn(0, 1, u / c || 0);
          }
          var a = n ? 'x' : 'y',
            f = t.Mr,
            l = t.Rr[a],
            s = f[a];
          return mn(0, 1, l / (l + s) || 0);
        },
        g = function (n) {
          return xn(n, { clear: ['left'] });
        },
        m = function (n) {
          d.forEach(function (r, t) {
            (!n || j(F(n), t)) &&
              (_(r || [], function (n) {
                n && n.cancel();
              }),
              d.delete(t));
          });
        },
        w = function (n, r, t, e) {
          var i = d.get(n) || [],
            o = i.find(function (n) {
              return n && n.timeline === r;
            });
          o ? (o.effect = new KeyframeEffect(n, t, { composite: e })) : d.set(n, z(i, [n.animate(t, { timeline: r, composite: e })]));
        },
        O = function (n, r, t) {
          var e = t ? In : Hn;
          _(n, function (n) {
            e(n.Vr, r);
          });
        },
        S = function (n, r) {
          _(n, function (n) {
            var t = r(n);
            Zn(t[0], t[1]);
          });
        },
        P = function (n, r) {
          S(n, function (n) {
            var t;
            return [n.Ir, ((t = {}), (t[r ? rn : tn] = Un(b(r))), t)];
          });
        },
        C = function (n, r) {
          var e = t.Fr,
            i = r ? 'x' : 'y',
            o = y[i],
            u = Or(e)[i],
            c = function (n, t) {
              return er(
                Un(
                  (function (n, r, t) {
                    var e = b(t, n);
                    return (1 / e) * (1 - e) * r;
                  })(n, u ? t : 1 - t, r)
                ),
                r
              );
            };
          o
            ? _(n, function (n) {
                var r = n.Ir;
                w(
                  r,
                  o,
                  g({
                    transform: [0, 1].map(function (r) {
                      return c(n, r);
                    }),
                  })
                );
              })
            : S(n, function (n) {
                return [n.Ir, { transform: c(n, Sr(e, mr(f))[i]) }];
              });
        },
        D = function (n) {
          return s && !l && _n(n) === c;
        },
        k = [],
        E = [],
        T = [],
        H = function (n, r, t) {
          var e = M(t),
            i = !e || !t;
          (!e || t) && O(E, n, r), i && O(T, n, r);
        },
        I = function (n) {
          var r = Yn(et + ' ' + (n ? ot : ut)),
            t = Yn(ct),
            i = Yn(at),
            o = { Vr: r, kr: t, Ir: i };
          return $(n ? E : T, o), $(k, [Bn(r, t), Bn(t, i), vn(Nn, r), m, e(o, H, C, n)]), o;
        },
        A = vn(I, !0),
        L = vn(I, !1);
      return (
        A(),
        L(),
        [
          {
            jr: function () {
              P(E, !0), P(T);
            },
            Nr: function () {
              C(E, !0), C(T);
            },
            Ur: function () {
              if (s) {
                var n = t.Mr,
                  r = t.Fr,
                  e = Or(r),
                  i = 0.5;
                if (y.x && y.y)
                  _(z(T, E), function (r) {
                    var t = r.Vr;
                    if (D(t)) {
                      var o = function (r) {
                        return w(
                          t,
                          y[r],
                          g({
                            transform: [0, e[r] ? 1 : -1].map(function (t) {
                              return er(Qn(t * (n[r] - i)), 'x' === r);
                            }),
                          }),
                          'add'
                        );
                      };
                      o('x'), o('y');
                    } else m(t);
                  });
                else {
                  var o = Sr(r, mr(f)),
                    u = function (r) {
                      var t = r.Vr,
                        i = D(t) && t,
                        u = function (n, r, t) {
                          var e = r * n;
                          return Qn(t ? e : -e);
                        };
                      return [i, i && { transform: er({ x: u(o.x, n.x, e.x), y: u(o.y, n.y, e.y) }) }];
                    };
                  S(E, u), S(T, u);
                }
              }
            },
            qr: H,
            Br: { M: y.x, Yr: E, Wr: A, Xr: vn(S, E) },
            Zr: { M: y.y, Yr: T, Wr: L, Xr: vn(S, T) },
          },
          function () {
            return Bn(h, E[0].Vr), Bn(h, T[0].Vr), vn(Y, k);
          },
        ]
      );
    },
    Wt = function (n, r, t, e) {
      return function (i, o, a, f) {
        var l = r.gr,
          v = r.er,
          d = r.ar,
          p = r.hr,
          y = r.Kr,
          h = r.yr,
          x = i.Vr,
          b = i.kr,
          g = i.Ir,
          m = dn(333),
          w = m[0],
          O = m[1],
          S = dn(444),
          P = S[0],
          C = S[1],
          D = dn(),
          M = D[0],
          E = D[1],
          T = vn(a, [i], f),
          H = function (n) {
            k(p.scrollBy) && p.scrollBy({ behavior: 'smooth', left: n.x, top: n.y });
          },
          I = f ? rn : tn,
          A = !0,
          L = function (n) {
            return n.propertyName.indexOf(I) > -1;
          };
        return vn(Y, [
          yr(g, 'pointermove pointerleave', e),
          yr(x, 'pointerenter', function () {
            o(st, !0);
          }),
          yr(x, 'pointerleave pointercancel', function () {
            o(st, !1);
          }),
          !d &&
            yr(x, 'mousedown', function () {
              var n = zn();
              (Sn(n, zr) || Sn(n, _r) || n === document.body) &&
                s(function () {
                  v.focus({ preventScroll: !0 });
                }, 25);
            }),
          yr(
            x,
            'wheel',
            function (n) {
              var r = n.deltaX,
                t = n.deltaY,
                e = n.deltaMode;
              A && 0 === e && _n(x) === l && H({ x: r, y: t }),
                (A = !1),
                o(yt, !0),
                w(function () {
                  (A = !0), o(yt);
                }),
                xr(n);
            },
            { A: !1, H: !0 }
          ),
          yr(g, 'transitionstart', function (n) {
            L(n) &&
              (function n() {
                T(), M(n);
              })();
          }),
          yr(g, 'transitionend transitioncancel', function (n) {
            L(n) && (E(), T());
          }),
          yr(x, 'pointerdown', vn(yr, y, 'click', br, { T: !0, H: !0, A: !1 }), { H: !0 }),
          (function () {
            var r = 'pointerup pointercancel lostpointercapture',
              e = 'client' + (f ? 'X' : 'Y'),
              i = f ? 'left' : 'top',
              o = f ? 'w' : 'h',
              a = f ? 'x' : 'y',
              l = function (n, r) {
                return function (e) {
                  var i,
                    u = t.Mr,
                    c = cr(b)[o] - cr(g)[o],
                    f = ((r * e) / c) * u[a];
                  gr(p, (((i = {})[a] = n + f), i));
                };
              };
            return yr(b, 'pointerdown', function (t) {
              var f = jn(t.target, '.' + at) === g,
                s = f ? g : b,
                v = n.scrollbars,
                d = t.button,
                x = t.isPrimary,
                m = t.pointerType,
                w = v.pointers;
              if (0 === d && x && v[f ? 'dragScroll' : 'clickScroll'] && (w || []).includes(m)) {
                C();
                var O = !f && t.shiftKey,
                  S = vn(sr, g),
                  D = vn(sr, b),
                  M = function (n, r) {
                    return (n || S())[i] - (r || D())[i];
                  },
                  k = u(sr(p)[I]) / cr(p)[o] || 1,
                  E = l(mr(p)[a], 1 / k),
                  T = t[e],
                  A = S(),
                  L = D(),
                  R = A[I],
                  V = M(A, L) + R / 2,
                  _ = T - L[i],
                  j = f ? 0 : _ - V,
                  z = function (n) {
                    Y(B), s.releasePointerCapture(n.pointerId);
                  },
                  N = function () {
                    return h(Yr, !0);
                  },
                  F = N(),
                  B = [
                    function () {
                      var n = mr(p);
                      F();
                      var r = mr(p),
                        t = { x: r.x - n.x, y: r.y - n.y };
                      (c(t.x) > 3 || c(t.y) > 3) && (N(), gr(p, n), H(t), P(F));
                    },
                    yr(y, r, z),
                    yr(
                      y,
                      'selectstart',
                      function (n) {
                        return xr(n);
                      },
                      { A: !1 }
                    ),
                    yr(b, r, z),
                    yr(b, 'pointermove', function (n) {
                      var r = n[e] - T;
                      (f || O) && E(j + r);
                    }),
                  ];
                if ((s.setPointerCapture(t.pointerId), O)) E(j);
                else if (!f) {
                  var W = Et(jt);
                  W && $(B, W(E, M, j, R, _));
                }
              }
            });
          })(),
          O,
          C,
          E,
        ]);
      };
    },
    Yt = function (n) {
      var r = bt(),
        t = r.V,
        i = r.I,
        o = t().elements,
        u = o.host,
        c = o.padding,
        a = o.viewport,
        f = o.content,
        l = A(n),
        s = l ? {} : n,
        v = s.elements || {},
        d = v.host,
        p = v.padding,
        y = v.viewport,
        h = v.content,
        x = l ? n : s.target,
        b = Rn(x),
        g = Ln(x, 'textarea'),
        m = x.ownerDocument,
        w = m.documentElement,
        O = function () {
          return m.defaultView || e;
        },
        S = function (n) {
          n && n.focus && n.focus({ preventScroll: !0 });
        },
        P = vn(mt, [x]),
        C = vn(wt, [x]),
        D = vn(Yn, ''),
        M = vn(P, D, a),
        k = vn(C, D, f),
        E = M(y),
        T = E === x,
        H = T && b,
        I = !T && k(h),
        L = !T && E === I,
        R = H ? w : E,
        V = g ? P(D, u, d) : x,
        _ = H ? R : V,
        z = !T && C(D, c, p),
        N = !L && I,
        F = [N, R, z, _].map(function (n) {
          return A(n) && !_n(n) && n;
        }),
        B = function (n) {
          return n && j(F, n);
        },
        W = B(R) ? x : R,
        J = {
          _r: x,
          gr: _,
          er: R,
          na: z,
          mr: N,
          hr: H ? w : R,
          Gr: H ? m : R,
          ia: b ? w : W,
          Kr: m,
          br: g,
          Lr: b,
          zr: l,
          ar: T,
          va: O,
          Sr: function (n) {
            return (function (n, r, t) {
              return Dn(n, r).C(t);
            })(R, zr, n);
          },
          yr: function (n, r) {
            return En(R, zr, n, r);
          },
        },
        X = J._r,
        q = J.gr,
        G = J.na,
        K = J.er,
        U = J.mr,
        Q = [
          function () {
            Cn(q, [_r, Lr]), Cn(X, Lr), b && Cn(w, [Lr, _r]);
          },
        ],
        Z = g && B(q),
        nn = g
          ? X
          : Vn(
              [U, K, G, q, X].find(function (n) {
                return n && !B(n);
              })
            ),
        rn = H ? X : U || K,
        tn = vn(Y, Q);
      return [
        J,
        function () {
          var n = O(),
            r = zn(),
            t = function (n) {
              Bn(_n(n), Vn(n)), Nn(n);
            },
            e = function (n) {
              return yr(n, 'focusin focusout focus blur', hr, { H: !0 });
            },
            o = 'tabindex',
            u = On(K, o),
            c = e(r);
          return (
            Pn(q, _r, T ? '' : jr),
            Pn(G, Xr, ''),
            Pn(K, zr, ''),
            Pn(U, qr, ''),
            T || (Pn(K, o, u || '-1'), b && Pn(w, Vr, '')),
            Z &&
              (Wn(X, q),
              $(Q, function () {
                Wn(q, X), Nn(q);
              })),
            Bn(rn, nn),
            Bn(q, G),
            Bn(G || q, !T && K),
            Bn(K, U),
            $(Q, [
              c,
              function () {
                var n = zn(),
                  r = e(n);
                Cn(G, Xr), Cn(U, qr), Cn(K, zr), b && Cn(w, Vr), u ? Pn(K, o, u) : Cn(K, o), B(U) && t(U), B(K) && t(K), B(G) && t(G), S(n), r();
              },
            ]),
            i && !T && (kn(K, zr, Wr), $(Q, vn(Cn, K, zr))),
            S(T || r !== x || n.top !== n ? r : K),
            c(),
            (nn = 0),
            tn
          );
        },
        tn,
      ];
    },
    Jt = function (n) {
      var r = n.mr;
      return function (n) {
        var t,
          e = n.$r,
          i = n.oa,
          o = n.Dr,
          u = (e || {}).Cr,
          c = i.wr;
        r && (u || o) && Zn(r, (((t = {})[tn] = c && '100%'), t));
      };
    },
    Xt = function (n, t) {
      var e = n.gr,
        i = n.na,
        o = n.er,
        u = n.ar,
        c = r({ v: ln, i: tr() }, vn(tr, e, 'padding', '')),
        a = c[0],
        f = c[1];
      return function (n) {
        var r = n.Tr,
          e = n.$r,
          c = n.oa,
          l = n.Dr,
          s = f(l),
          v = s[0],
          d = s[1],
          p = bt().I,
          y = e || {},
          h = y.pr,
          x = y.Er,
          b = y.Or,
          g = c.ir,
          m = r('paddingAbsolute'),
          w = m[0],
          O = m[1];
        if (h || d || l || x) {
          var S = a(l);
          (v = S[0]), (d = S[1]);
        }
        var P = !u && (O || b || d);
        if (P) {
          var C,
            D,
            M = !w || (!i && !p),
            k = v.r + v.l,
            E = v.t + v.b,
            T = (((C = {})[U] = M && !g ? -k : 0), (C[Q] = M ? -E : 0), (C[K] = M && g ? -k : 0), (C.top = M ? -v.t : 0), (C.right = M ? (g ? -v.r : 'auto') : 0), (C.left = M ? (g ? 'auto' : -v.l) : 0), (C[rn] = M && 'calc(100% + ' + k + 'px)'), C),
            H = (((D = {})[J] = M ? v.t : 0), (D[X] = M ? v.r : 0), (D[G] = M ? v.b : 0), (D[q] = M ? v.l : 0), D);
          Zn(i || o, T), Zn(o, H), xn(t, { na: v, ua: !M, vr: i ? H : xn({}, T, H) });
        }
        return { ca: P };
      };
    },
    qt = function (n, t) {
      var o = bt(),
        u = n.gr,
        c = n.na,
        a = n.er,
        f = n.ar,
        l = n.hr,
        s = n.Lr,
        v = n.yr,
        d = n.va,
        p = o.I,
        y = s && f,
        h = vn(i, 0),
        x = ['display', 'direction', 'flexDirection', 'writingMode'],
        b = { v: an, i: { w: 0, h: 0 } },
        g = { v: fn, i: {} },
        m = function (n, r) {
          var t = e.devicePixelRatio % 1 != 0 ? 1 : 0,
            i = { w: h(n.w - r.w), h: h(n.h - r.h) };
          return { w: i.w > t ? i.w : 0, h: i.h > t ? i.h : 0 };
        },
        w = function () {
          var n = mr(l),
            r = v(Jr, !0),
            t = yr(l, un, hr, { H: !0 });
          gr(l, { x: 0, y: 0 }), r();
          var e = mr(l),
            i = fr(l);
          gr(l, { x: i.w, y: i.h });
          var o = mr(l);
          gr(l, { x: o.x - e.x < 1 && -i.w, y: o.y - e.y < 1 && -i.h });
          var u = mr(l);
          return gr(l, n), t(), { P: e, D: u };
        },
        O = function () {
          return xn(
            {},
            (function (n) {
              return (
                !!n &&
                (function (n) {
                  return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length);
                })(n)
              );
            })(a)
              ? nr(a, x)
              : {}
          );
        },
        S = r(b, vn(lr, a)),
        P = S[0],
        C = S[1],
        D = r(b, vn(fr, a)),
        M = D[0],
        k = D[1],
        E = r(b),
        T = E[0],
        H = E[1],
        I = r(g)[0],
        A = r(b),
        L = A[0],
        R = A[1],
        V = r(g)[0],
        j = r({
          v: function (n, r) {
            return cn(n, r, x);
          },
          i: {},
        }),
        z = j[0],
        $ = r({
          v: function (n, r) {
            return fn(n.P, r.P) && fn(n.D, r.D);
          },
          i: { P: { x: 0, y: 0 }, D: { x: 0, y: 0 } },
        }),
        N = $[0],
        F = $[1],
        B = Et(Vt),
        W = function (n, r) {
          return (
            '' +
            (r ? $r : Nr) +
            (function (n) {
              var r = String(n || '');
              return r ? r[0].toUpperCase() + r.slice(1) : '';
            })(n)
          );
        },
        Y = function (n) {
          var r = n.$;
          _(hn(r), function (n) {
            var t = 'x' === n,
              e = [en, on, un].map(function (n) {
                return W(n, t);
              });
            v(e.join(' ')), v(W(r[n], t), !0);
          });
        };
      return function (r, e) {
        var f = r.Tr,
          l = r.$r,
          s = r.oa,
          x = r.Dr,
          b = e.ca,
          g = l || {},
          S = g.pr,
          D = g.Er,
          E = g.Or,
          A = g.dr,
          _ = g.Hr,
          j = (B && B.rr(n, t, s, o, f)) || {},
          $ = j.cr,
          W = j.lr,
          J = j.sr,
          X = At(f, o),
          q = X[0],
          G = X[1],
          K = f('overflow'),
          U = K[0],
          Q = K[1],
          Z = Lt(U.x),
          nn = Lt(U.y),
          rn = S || b || D || E || _ || G,
          tn = C(x),
          en = k(x),
          on = H(x),
          un = R(x);
        if ((G && p && v(Wr, !q), rn)) {
          var cn = (W ? W() : [])[0],
            an = (tn = P(x))[0],
            fn = (en = M(x))[0],
            ln = ar(a),
            sn = fn,
            vn = ln;
          cn && cn();
          var dn = ur(d()),
            pn = { w: h(i(fn.w, sn.w) + an.w), h: h(i(fn.h, sn.h) + an.h) },
            yn = { w: h((y ? dn.w : vn.w + h(ln.w - fn.w)) + an.w), h: h((y ? dn.h : vn.h + h(ln.h - fn.h)) + an.h) };
          (un = L(yn)), (on = T(m(pn, yn), x));
        }
        var hn = un,
          bn = hn[0],
          gn = hn[1],
          mn = on,
          wn = mn[0],
          On = mn[1],
          Sn = en,
          Pn = Sn[0],
          Cn = Sn[1],
          Dn = tn,
          Mn = Dn[0],
          kn = Dn[1],
          Tn = I({ x: wn.w > 0, y: wn.h > 0 }),
          Hn = Tn[0],
          In = Tn[1],
          An = (Z && nn && (Hn.x || Hn.y)) || (Z && Hn.x && !Hn.y) || (nn && Hn.y && !Hn.x),
          Ln = b || E || _ || kn || Cn || gn || On || Q || G || rn,
          Rn = Rt(Hn, U),
          Vn = V(Rn.$),
          _n = Vn[0],
          jn = Vn[1],
          zn = z(O(), x)[1],
          $n = E || A || zn || In || x ? N(w(), x) : F(),
          Nn = $n[0],
          Fn = $n[1];
        return Ln && (Y(Rn), J && $ && Zn(a, J(Rn, s, $(Rn, Pn, Mn)))), En(u, _r, Rr, An), En(c, Xr, Rr, An), xn(t, { $: _n, Rr: { x: bn.w, y: bn.h }, Mr: { x: wn.w, y: wn.h }, ta: Hn, Fr: wr(Nn, wn) }), { aa: jn, Qr: gn, ra: On, ea: Fn || On };
      };
    },
    Gt = function n(r, t, e) {
      var i = bt().j,
        o = A(r),
        u = o ? r : r.target,
        c = Pt(u);
      if (t && !c) {
        var a = !1,
          f = [],
          l = {},
          s = function (n) {
            var r = bn(n, !0),
              t = Et(Tt);
            return t ? t(r, !0) : r;
          },
          v = xn({}, i(), s(t)),
          d = Cr(),
          p = d[0],
          y = d[1],
          h = d[2],
          x = Cr(e),
          b = x[0],
          g = x[1],
          m = x[2],
          w = function (n, r) {
            m(n, r), h(n, r);
          },
          O = (function (n, r, t, e) {
            var i = Tr(r, {}),
              o = (function (n) {
                var r,
                  t = Yt(n),
                  e = t[0],
                  i = t[1],
                  o = t[2],
                  u = { na: { t: 0, r: 0, b: 0, l: 0 }, ua: !1, vr: ((r = {}), (r[U] = 0), (r[Q] = 0), (r[K] = 0), (r[J] = 0), (r[X] = 0), (r[G] = 0), (r[q] = 0), r), Rr: { x: 0, y: 0 }, Mr: { x: 0, y: 0 }, $: { x: on, y: on }, ta: { x: !1, y: !1 }, Fr: { P: { x: 0, y: 0 }, D: { x: 0, y: 0 } } },
                  c = e._r,
                  a = e.hr,
                  f = e.ar,
                  l = e.yr,
                  s = bt(),
                  v = s.I,
                  d = s.k,
                  p = !v && (d.x || d.y),
                  y = [Jt(e), Xt(e, u), qt(e, u)];
                return [
                  i,
                  function (n) {
                    var r = {},
                      t = p,
                      e = l(Br, !0),
                      i = t && mr(a);
                    return (
                      _(y, function (t) {
                        xn(r, t(n, r) || {});
                      }),
                      gr(a, i),
                      !f && gr(c, 0),
                      e(),
                      r
                    );
                  },
                  u,
                  e,
                  o,
                ];
              })(n),
              u = o[0],
              c = o[1],
              a = o[2],
              f = o[3],
              l = o[4],
              s = Ft(f, a, i, function (n) {
                m({}, n);
              }),
              v = s[0],
              d = s[1],
              p = s[2],
              y = (function (n, r, t, e, i, o) {
                var u,
                  c,
                  a,
                  f,
                  l,
                  s = sn,
                  v = 0,
                  d = function (n) {
                    return 'mouse' === n.pointerType;
                  },
                  p = dn(),
                  y = p[0],
                  h = p[1],
                  x = dn(100),
                  b = x[0],
                  g = x[1],
                  m = dn(100),
                  w = m[0],
                  O = m[1],
                  S = dn(function () {
                    return v;
                  }),
                  P = S[0],
                  C = S[1],
                  D = Bt(
                    n,
                    i,
                    e,
                    Wt(r, i, e, function (n) {
                      return d(n) && _();
                    })
                  ),
                  M = D[0],
                  k = D[1],
                  E = i.gr,
                  T = i.Gr,
                  H = i.Lr,
                  I = M.qr,
                  A = M.jr,
                  L = M.Nr,
                  R = M.Ur,
                  V = function (n, r) {
                    if ((C(), n)) I(pt);
                    else {
                      var t = vn(I, pt, !0);
                      v > 0 && !r ? P(t) : t();
                    }
                  },
                  _ = function () {
                    (a ? u : f) ||
                      (V(!0),
                      b(function () {
                        V(!1);
                      }));
                  },
                  j = function (n) {
                    I(dt, n, !0), I(dt, n, !1);
                  },
                  z = function (n) {
                    d(n) && ((u = a), a && V(!0));
                  },
                  N = [
                    C,
                    g,
                    O,
                    h,
                    function () {
                      return s();
                    },
                    yr(E, 'pointerover', z, { T: !0 }),
                    yr(E, 'pointerenter', z),
                    yr(E, 'pointerleave', function (n) {
                      d(n) && ((u = !1), a && V(!1));
                    }),
                    yr(E, 'pointermove', function (n) {
                      d(n) && c && _();
                    }),
                    yr(T, 'scroll', function (n) {
                      y(function () {
                        L(), _();
                      }),
                        o(n),
                        R();
                    }),
                  ];
                return [
                  function () {
                    return vn(Y, $(N, k()));
                  },
                  function (n) {
                    var r = n.Tr,
                      i = n.Dr,
                      o = n.$r,
                      u = n.Jr || {},
                      d = u.Qr,
                      p = u.ra,
                      y = u.aa,
                      h = u.ea,
                      x = o || {},
                      b = x.Or,
                      g = x.dr,
                      m = t.ir,
                      O = bt().k,
                      S = e.$,
                      P = e.ta,
                      C = r('showNativeOverlaidScrollbars'),
                      D = C[0],
                      M = C[1],
                      k = r('scrollbars.theme'),
                      E = k[0],
                      _ = k[1],
                      z = r('scrollbars.visibility'),
                      $ = z[0],
                      N = z[1],
                      F = r('scrollbars.autoHide'),
                      B = F[0],
                      W = F[1],
                      Y = r('scrollbars.autoHideSuspend'),
                      J = Y[0],
                      X = Y[1],
                      q = r('scrollbars.autoHideDelay')[0],
                      G = r('scrollbars.dragScroll'),
                      K = G[0],
                      U = G[1],
                      Q = r('scrollbars.clickScroll'),
                      Z = Q[0],
                      nn = Q[1],
                      rn = r('overflow'),
                      tn = rn[0],
                      on = rn[1],
                      cn = g && !i,
                      an = P.x || P.y,
                      fn = d || p || h || b || i,
                      ln = y || N || on,
                      sn = D && O.x && O.y,
                      dn = function (n, r, t) {
                        var e = n.includes(un) && ($ === en || ('auto' === $ && r === un));
                        return I(ft, e, t), e;
                      };
                    if (
                      ((v = q),
                      cn &&
                        (J && an
                          ? (j(!1),
                            s(),
                            w(function () {
                              s = yr(T, 'scroll', vn(j, !0), { T: !0 });
                            }))
                          : j(!0)),
                      M && I(tt, sn),
                      _ && (I(l), I(E, !0), (l = E)),
                      X && !J && j(!0),
                      W && ((c = 'move' === B), (a = 'leave' === B), V((f = 'never' === B), !0)),
                      U && I(xt, K),
                      nn && I(ht, Z),
                      ln)
                    ) {
                      var pn = dn(tn.x, S.x, !0),
                        yn = dn(tn.y, S.y, !1);
                      I(lt, !(pn && yn));
                    }
                    fn && (A(), L(), R(), I(vt, !P.x, !0), I(vt, !P.y, !1), I(it, m && !H));
                  },
                  {},
                  M,
                ];
              })(n, r, p, a, f, function (n) {
                return w('scroll', [E, n]);
              }),
              h = y[0],
              x = y[1],
              b = y[3],
              g = function (n) {
                return hn(n).some(function (r) {
                  return !!n[r];
                });
              },
              m = function (n, t) {
                var e = n.la,
                  i = n.Dr,
                  o = n.Pr,
                  u = n.fa,
                  a = e || {},
                  f = !!i,
                  l = { Tr: Tr(r, a, f), la: a, Dr: f };
                if (u) return x(l), !1;
                var s = t || d(xn({}, l, { Pr: o })),
                  v = c(xn({}, l, { oa: p, $r: s }));
                x(xn({}, l, { $r: s, Jr: v }));
                var y = g(s),
                  h = g(v),
                  b = y || h || !gn(a) || f;
                return (
                  b &&
                    (function (n, r) {
                      var t = n.la,
                        e = n.Dr,
                        i = r.$r,
                        o = r.Jr,
                        u = i.pr,
                        c = i.Or,
                        a = i.Cr,
                        f = i.Er,
                        l = i.Ar,
                        s = i.dr,
                        v = o.Qr,
                        d = o.ra,
                        p = o.aa,
                        y = o.ea;
                      w('updated', [
                        E,
                        { updateHints: { sizeChanged: !!u, directionChanged: !!c, heightIntrinsicChanged: !!a, overflowEdgeChanged: !!v, overflowAmountChanged: !!d, overflowStyleChanged: !!p, scrollCoordinatesChanged: !!y, contentMutation: !!f, hostMutation: !!l, appear: !!s }, changedOptions: t || {}, force: !!e },
                      ]);
                    })(n, { $r: s, Jr: v }),
                  b
                );
              };
            return [
              function () {
                var n = f.ia,
                  r = f.hr,
                  t = (0, f.yr)(Br, !0),
                  e = mr(n),
                  i = [v(), u(), h()];
                return gr(r, e), t(), vn(Y, i);
              },
              m,
              function () {
                return { sa: p, da: a };
              },
              { pa: f, _a: b },
              l,
            ];
          })(r, v),
          S = O[0],
          P = O[1],
          C = O[2],
          D = O[3],
          M = O[4],
          k = function (n) {
            !(function (n) {
              St.delete(n);
            })(u),
              Y(f),
              (a = !0),
              w('destroyed', [E, n]),
              y(),
              g();
          },
          E = {
            options: function (n, r) {
              if (n) {
                var t = r ? i() : {},
                  e = Er(v, xn(t, s(n)));
                gn(e) || (xn(v, e), P({ la: e }));
              }
              return xn({}, v);
            },
            on: b,
            off: function (n, r) {
              n && r && g(n, r);
            },
            state: function () {
              var n = C(),
                r = n.sa,
                t = n.da,
                e = r.ir,
                i = t.Rr,
                o = t.Mr,
                u = t.$,
                c = t.ta,
                f = t.na,
                l = t.ua,
                s = t.Fr;
              return xn({}, { overflowEdge: i, overflowAmount: o, overflowStyle: u, hasOverflow: c, scrollCoordinates: { start: s.P, end: s.D }, padding: f, paddingAbsolute: l, directionRTL: e, destroyed: a });
            },
            elements: function () {
              var n = D.pa,
                r = n._r,
                t = n.gr,
                e = n.na,
                i = n.er,
                o = n.mr,
                u = n.hr,
                c = n.Gr,
                a = D._a,
                f = a.Br,
                l = a.Zr,
                s = function (n) {
                  var r = n.Ir,
                    t = n.kr;
                  return { scrollbar: n.Vr, track: t, handle: r };
                },
                v = function (n) {
                  var r = n.Yr,
                    t = n.Wr,
                    e = s(r[0]);
                  return xn({}, e, {
                    clone: function () {
                      var n = s(t());
                      return P({ fa: !0 }), n;
                    },
                  });
                };
              return xn({}, { target: r, host: t, padding: e || i, viewport: i, content: o || i, scrollOffsetElement: u, scrollEventElement: c, scrollbarHorizontal: v(f), scrollbarVertical: v(l) });
            },
            update: function (n) {
              return P({ Dr: n, Pr: !0 });
            },
            destroy: vn(k, !1),
            plugin: function (n) {
              return l[hn(n)[0]];
            },
          };
        return (
          $(f, [M]),
          (function (n, r) {
            St.set(n, r);
          })(u, E),
          kt(Dt, n, [E, p, l]),
          Ot(D.pa.Lr, !o && r.cancel) ? (k(!0), E) : ($(f, S()), w('initialized', [E]), E.update(!0), E)
        );
      }
      return c;
    };
  return (
    (Gt.plugin = function (n) {
      var r = E(n),
        t = r ? n : [n],
        e = t.map(function (n) {
          return kt(n, Gt)[0];
        });
      return (
        (function (n) {
          _(n, function (n) {
            return _(n, function (r, t) {
              Dt[t] = n[t];
            });
          });
        })(t),
        r ? e : e[0]
      );
    }),
    (Gt.valid = function (n) {
      var r = n && n.elements,
        t = k(r) && r();
      return I(t) && !!Pt(t.target);
    }),
    (Gt.env = function () {
      var n = bt(),
        r = n.L,
        t = n.k,
        e = n.I,
        i = n.M,
        o = n.U,
        u = n.q,
        c = n.V,
        a = n.F,
        f = n.j,
        l = n.N;
      return xn({}, { scrollbarsSize: r, scrollbarsOverlaid: t, scrollbarsHiding: e, scrollTimeline: i, staticDefaultInitialization: o, staticDefaultOptions: u, getDefaultInitialization: c, setDefaultInitialization: a, getDefaultOptions: f, setDefaultOptions: l });
    }),
    (n.ClickScrollPlugin = zt),
    (n.OverlayScrollbars = Gt),
    (n.ScrollbarsHidingPlugin = _t),
    (n.SizeObserverPlugin = It),
    n
  );
})({});
